module.exports = __webpack_public_path__ + "static/media/W.cc5c5874.svg";